module.exports = __webpack_public_path__ + "static/media/swiftly-610.d5ceca98.mp3";